/* AOP Budget's horizontal filter bar — one control per visible FILTERS_CONFIG
   key, extracted out of AOPBudget.js. Same control set/behavior Monthly DFR
   and Waterfall EAC use (Select / GlobalMultiSelectFilter / text /
   HorizontalDateRangeFilter, switched on `f.type`). */
import React from "react";
import { Select } from "antd";
import {
  HorizontalDateRangeFilter,
  FilterApplyButton,
} from "../GlobalFilterPanel";
import {
  getFilterFieldOptions,
  toFilterSelectOptions,
  FILTER_SELECT_SEARCH_PROPS,
  GlobalMultiSelectFilter,
} from "../filterRelationshipUtils";
import { filtersForKeys } from "./aopBudgetFilterHelpers";

export default function AOPBudgetFilterBar({
  visibleKeys,
  draft,
  dropdownOptions,
  onChange,
  onClearAll,
  onApply,
  onClose,
  classes,
  clearAllDisabled,
  applyDisabled,
}) {
  const filters = filtersForKeys(visibleKeys);
  const selectStyle = { minWidth: 110, maxWidth: 180, fontSize: 12 };

  return (
    <div className={classes.hFilterBar}>
      {filters.map((f) => {
        const opts = toFilterSelectOptions(f.key, getFilterFieldOptions(f, dropdownOptions));
        const val = draft[f.key];
        return (
          <div key={f.key} className={classes.hFilterGroup}>
            <span className={classes.hFilterLabel}>{f.label}</span>
            {f.type === "select" && (
              <Select
                size="small"
                style={selectStyle}
                value={val || (f.key === "year" ? opts[0]?.value : "All")}
                onChange={(v) => onChange(f.key, v === "All" ? f.defaultValue : v)}
                options={f.key === "year" ? opts : [{ value: "All", label: "All" }, ...opts]}
                {...FILTER_SELECT_SEARCH_PROPS}
                popupMatchSelectWidth={false}
              />
            )}
            {f.type === "multiselect" && (
              <GlobalMultiSelectFilter
                size="small"
                style={selectStyle}
                value={val}
                options={opts}
                onChange={(v) => onChange(f.key, v)}
                {...FILTER_SELECT_SEARCH_PROPS}
                popupMatchSelectWidth={false}
              />
            )}
            {f.type === "text" && (
              <input
                className={classes.hFilterInput}
                value={val || ""}
                placeholder="All"
                onChange={(e) => onChange(f.key, e.target.value)}
              />
            )}
            {f.type === "daterange" && (
              <HorizontalDateRangeFilter value={val} onChange={(next) => onChange(f.key, next)} />
            )}
          </div>
        );
      })}
      <div className={classes.hFilterActions}>
        <button className={classes.hFilterClearAll} onClick={onClearAll} disabled={clearAllDisabled}>
          Clear All
        </button>
        <FilterApplyButton draft={draft} onApply={onApply} className={classes.hFilterApply} disabled={applyDisabled}>
          Apply
        </FilterApplyButton>
      </div>
      <button className={classes.hFilterClose} onClick={onClose} title="Close Filters">
        ✕
      </button>
    </div>
  );
}
